import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";
//import PhasesAdd from './../../elements/phases/widget/phases_add';

class Phases extends Component {
	render(){
		return(
			<PhasesList {...this.props}/>
		);
	}

	componentWillMount(){
		this.props.phasesShow(this.props.phases.current);
	}
}

export class PhasesList extends Component{
	render() {
		const {phases} = this.props;
		let pu = _.find(phases.permissions, (o) => {return o==='Update'});
		let pd = _.find(phases.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{phases.isFetching ? <Loading /> :
					<table className={`inm-table`}>
						<thead>
						<tr>
							<th>ID</th>
							<th>Nombre de Subproceso</th>
							<th>Estatus</th>
						</tr>
						</thead>
						<tbody>
						{_.map(phases.list,(row, k) => {
							return (
								<tr key={k}>
									<td style={{width:10+'%'}}>
										<div className="actions">
											{pu ? <NavLink to={`/fases/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
											{pd ? <button onClick={() => this._getConfirm(row.id,row.name)}><i className="fa fa-trash-o"></i></button>:''}
										</div>
										{row.id}
									</td>
									<td >{row.name}</td>
									<td>
										<strong className={`has-text-${row.status.style}`}>
											{row.status.name}
										</strong>
									</td>
								</tr>
							)
						})}
						</tbody>
					</table>}
				{phases.pages.total>20 &&
				<InmPagination key="concepts-pages" current={phases.pages.current} total={phases.pages.total} nextPage={this._handlePageChange}/>}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_handlePageChange(value) {
		this.props.phasesShow(value);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el Sub-proceso "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.phaseDelete(id)
		})
	}
}

//export default BaseLayout(Phases, {title:`Administrar Fases`});
export default BaseLayout(Phases, {
	title:"Administrar Subprocesos",
	subnav: {
		icon: 'fa-sliders',
		name: 'Administración',
		actions: [
			{
				type: null,
				url: null,
				name: '',
				element: null
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/phases/index.jsx